














import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import OperatorFilters from '@/components/OperatorFilters.vue';
import BulkTargeting from '@/components/BulkTargeting.vue';
import OperatorCard from '@/components/OperatorCard.vue';
import { OperatorModel } from '@/models/Operator';

const module = namespace('OperatorStore');

@Component({
  components: {
    OperatorFilters,
    BulkTargeting,
    OperatorCard,
  },
})
export default class Operators extends Vue {
    @module.State private operators!: OperatorModel[];

    @module.Action('init') private init!: () => void;

    protected created() {
        this.init();
    }
}
